import ControlledDropdown from '../ControlledDropdown';
import { DropdownOption } from '../DropDown';
import { useEffect, useState } from 'react';
import ProcedureList from '@src/cache/ProcedureList';

interface Props {
  fieldName: string;
}

function ControlledProcedureAutoComplete({ fieldName }: Props) {
  const [available, setAvailable] = useState<DropdownOption[]>([]);
  const { getList } = ProcedureList();

  useEffect(() => {
    getList().then((result) => {
      const items = result
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((item) => ({
          id: item.id || '',
          name: item.name,
          specialiatyId: item.specialityId ? item.specialityId : '',
        }));
      setAvailable(items);
    });
  }, [getList]);

  return (
    <ControlledDropdown
      fieldName={fieldName}
      label="Procedure"
      options={available}
    />
  );
}
export default ControlledProcedureAutoComplete;
